export function classNames(values?: (string | undefined)[]): string {
    if (values != null) {
        return values.join(' ').trim();
    }
    return '';
}
